// Âm lượng streamer đặt cho phần chèn OBS: tiếng thông báo donate, giọng đọc kèm ghi âm lời nhắn, nhạc người xem gửi.
// Máy chủ lưu số nguyên 0–100 (phần trăm), mặc định 100 = to như trước khi có tính năng.
// Hàm thuần dùng chung cho overlay, khu Cài đặt và bảng điều khiển phát nhạc.

export const DEFAULT_VOLUME = 100;
export const MIN_VOLUME = 0;
export const MAX_VOLUME = 100;

/**
 * Số lạ (null, chuỗi rỗng, NaN, sai kiểu) ⇒ `fallback` (mặc định 100, máy chủ cũ chưa trả trường này thì vẫn to như cũ).
 * Số hợp lệ làm tròn rồi kẹp về 0–100.
 */
export const normalizeVolume = (raw: unknown, fallback: number = DEFAULT_VOLUME): number => {
  if (typeof raw !== 'number' && !(typeof raw === 'string' && raw.trim() !== '')) return fallback;
  const n = Number(raw);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(MAX_VOLUME, Math.max(MIN_VOLUME, Math.round(n)));
};

/** 0–100 ⇒ 0–1 cho `HTMLMediaElement.volume`. */
export const volumeToGain = (volume: unknown): number => normalizeVolume(volume) / 100;

/** Đặt âm lượng cho thẻ audio/video. Thiếu phần tử hoặc trình duyệt từ chối thì bỏ qua, không làm hỏng overlay. */
export const applyVolume = (el: HTMLMediaElement | null | undefined, volume: unknown): void => {
  if (!el) return;
  const media = el; // đổi thuộc tính của thẻ được truyền vào là đúng ý đồ của hàm
  try {
    media.volume = volumeToGain(volume);
  } catch {
    // bỏ qua
  }
};

export interface AlertVolumes {
  alertVolume: number;
  voiceVolume: number;
}

export const DEFAULT_ALERT_VOLUMES: AlertVolumes = {
  alertVolume: DEFAULT_VOLUME,
  voiceVolume: DEFAULT_VOLUME,
};

/** Đọc hai mức âm lượng thông báo donate từ phản hồi giao diện thông báo; thiếu trường nào thì trường đó 100. */
export const readAlertVolumes = (raw: unknown): AlertVolumes => {
  const r = (raw && typeof raw === 'object' ? raw : {}) as Record<string, unknown>;
  return {
    alertVolume: normalizeVolume(r.alertVolume),
    voiceVolume: normalizeVolume(r.voiceVolume),
  };
};
